import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import EquipmentBySectorChart from '../../GenerateReport/components/charts/quantitative/equipmentBySector.vue'
import AlienatedEquip from '../../GenerateReport/components/charts/quantitative/alienatedEquip.vue'
import RequestBySector from '../../GenerateReport/components/charts/quantitative/requestBySector.vue'
import StoppedEquipPendingType from '../../GenerateReport/components/charts/quantitative/stoppedEquipPendingType.vue'
import TopFiveEquipFailures from '../../GenerateReport/components/charts/quantitative/topFiveEquipFailures.vue'
import DefectSolutionPrev from '../../GenerateReport/components/charts/quantitative/defectSolutionPrev.vue'
import SolicitedVConcluded from '../../GenerateReport/components/charts/quantitative/solicitedVConcluded.vue'
import CorrectiveScheXExec from '../../GenerateReport/components/charts/quantitative/correctiveSchedXExec.vue'
import InternalResolvability from '../../GenerateReport/components/charts/quantitative/internalResolvability.vue'
import PreventiveXCorrective from '../../GenerateReport/components/charts/quantitative/preventiveXCorrective.vue'
import PreventiveSchedXExec from '../../GenerateReport/components/charts/quantitative/preventiveSchedxExec.vue'
import CalibSchedXExec from '../../GenerateReport/components/charts/quantitative/calibSchedXExec.vue'
import EletricSecSchedXExec from '../../GenerateReport/components/charts/quantitative/eletricSecSchedXExec.vue'
import ValidationQualificationSchedXExec from '../../GenerateReport/components/charts/quantitative/validationQualificationSchedXExec.vue'
import ScheduledMaintenance from '../../GenerateReport/components/charts/quantitative/scheduledMaintenance.vue'
import HistoricalMigration from '../../GenerateReport/components/charts/quantitative/historicalMigration.vue'
import OrderByWorkshop from '../../GenerateReport/components/charts/quantitative/orderByWorkshop.vue'
import ResponsibleServicesByWeek from '../../GenerateReport/components/charts/quantitative/responsibleServicesByWeek.vue'
import RequestsPerCostCenter from '../../GenerateReport/components/charts/quantitative/requestsPerCostCenter.vue'
import RecurringCalls from '../../GenerateReport/components/charts/quantitative/recurringCalls.vue'
import InappropriateUseEquipment from '../../GenerateReport/components/charts/quantitative/inappropriateUseEquipment.vue'
import InspectionSchedXExec from '../../GenerateReport/components/charts/quantitative/inspectionSchedXExec.vue'
import PendingOsByType from '../../GenerateReport/components/charts/quantitative/pendingOsByType.vue'

import {
  getIndicatorById,
  getVisibleIndicators,
  getCategoryById,
} from '../../../indicators/indicatorRegistry'
import moment from 'moment'

export default {
  components: {
    EquipmentBySectorChart,
    AlienatedEquip,
    RequestBySector,
    StoppedEquipPendingType,
    TopFiveEquipFailures,
    DefectSolutionPrev,
    SolicitedVConcluded,
    CorrectiveScheXExec,
    InternalResolvability,
    PreventiveXCorrective,
    PreventiveSchedXExec,
    CalibSchedXExec,
    EletricSecSchedXExec,
    ValidationQualificationSchedXExec,
    ScheduledMaintenance,
    HistoricalMigration,
    OrderByWorkshop,
    ResponsibleServicesByWeek,
    RequestsPerCostCenter,
    RecurringCalls,
    InappropriateUseEquipment,
    InspectionSchedXExec,
    PendingOsByType,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.getInstitutions()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.filter.institutionId = this.institutionId

    if (this.institution.userType == 5) {
      this.unidadeIds = [userLogged.unidadeId]
    }

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.setDates()

    this.getWorkshops()
  },

  data: () => ({
    institutionSearch: '',
    workshopSearch: '',
    unitySearch: '',
    institution: {},
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    minDate: null,
    page: 1,
    pageSize: 14,
    institutionId: null,
    institutions: [],
    unidadeIds: null,
    unidades: [],
    userLogged: {},
    workshopTypes: [
      { text: 'Engenharia Clínica', value: 0 },
      { text: 'Carpintaria', value: 1 },
      { text: 'Elétrica', value: 2 },
      { text: 'Hidráulica', value: 3 },
      { text: 'Climatização', value: 4 },
      { text: 'Gasoterapia', value: 5 },
      { text: 'Zeladoria', value: 6 },
      { text: 'Vidraçaria', value: 7 },
      { text: 'Mecânica', value: 8 },
      { text: 'Serralheria', value: 9 },
      { text: 'Predial Civil', value: 10 },
      { text: 'Pintura Predial', value: 11 },
      { text: 'Pintura Industrial', value: 12 },
    ],
    filter: {
      page: 1,
      pageSize: 14,
      institutionId: null,
      unidadeIds: [],
      workshops: [],
      startDate: null,
      endDate: null,
    },
    apiService: new ApiService(),
  }),

  methods: {
    indicatorTitle(id) {
      const ind = getIndicatorById(id)
      if (!ind) return ''
      const cat = getCategoryById(ind.categoryId)
      const visible = getVisibleIndicators(ind.categoryId, this.institution)
      const found = visible.find((v) => v.id === id)
      if (!found || !cat) return ind.nameKey
      return `${cat.prefix}.${found.displayNumber} - ${this.$t(ind.nameKey)}`
    },
    removeWorkshop(item) {
      this.filter.workshops.splice(item, 1)
      this.filter.workshops = [...this.filter.workshops]
    },
    removeUnity(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },
    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    filterTables() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionId = this.institutionId
      this.filter.unidadeIds = this.unidadeIds

      this.setDates()

      for (const refName of Object.keys(this.$refs)) {
        const ref = this.$refs[refName]
        if (ref && typeof ref.list === 'function') ref.list()
      }
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeIds = [this.userLogged.unidadeId]
      } else {
        this.unidadeIds = []
      }

      this.filter = {
        page: 1,
        pageSize: 14,
        institutionId: null,
        workshops: [],
        unidadeIds: [],
        startDate: null,
        endDate: null,
      }
      ;(this.startDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        1
      )
        .toISOString()
        .substr(0, 7)),
        (this.endDate = new Date().toISOString().substr(0, 7)),
        (this.filterStartDate = null)
      this.filterEndDate = null

      this.filterTables()
    },

    getFirstDayLastMonth(date) {
      return Utils.getFirstDayLastMonth(date)
    },

    getEndDayLastMonth(date) {
      return Utils.getEndDayLastMonth(date)
    },
  },
}
